export default defineNuxtPlugin(() => {
  // Plugin is currently disabled
  // Uncomment and configure when Supabase integration is needed
  
  // import { createClient } from '@supabase/supabase-js'
  // const supabaseUrl = process.env.SUPABASE_URL
  // const supabaseKey = process.env.SUPABASE_KEY
  // const supabase = createClient(supabaseUrl, supabaseKey)
  // return {
  //   provide: {
  //     supabase
  //   }
  // }
})
